export const text = {
  TodoId: "Taak-ID",
  TeamId: "Team-ID",
  TeamName: "Teamnaam",
  MyTeam: "Mijn team",
  AddMyTeam: "Mijn team toevoegen",
  TeamName: "Teamnaam",
  TodoType: "Todo type",
  SelectTodoType: "Selecteer taaktype",
  Poll: "Peiling",
  Subjective: "Open vraag",
  Objective: "Meerkeuzevraag ",
  AddTeamTodo: "Team todo toevoegen",
  AddTeamGroup: "Teamgroep toevoegen",
  Pleaseaddteamgroupname: "Voeg een teamgroepsnaam toe",
  Teamgroupaddedsuccessfully: "Teamgroep succesvol toegevoegd",
  Teamgroupupdatedsuccessfully: "Teamgroep succesvol bijgewerkt",
  TeamTodo: "Team todo",
  TodoSubmission: "Todo indiening",
  TeamGroup: "Team groep",
  Myteamaddedsuccessfully: "Mijn team succesvol toegevoegd",
  Myteamupdatedsuccessfully: "Mijn team succesvol bijgewerkt",
  MyteamDeletedsuccessfully: "Mijn team succesvol verwijderd",
  PleaseaddQuestiontoyourteamtodo: "Voeg een vraag toe aan uw teamtaak",
  Teamtodoaddedsuccessfully: "Teamtaak succesvol toegevoegd",
  Teamtodoupdatedsuccessfully: "Teamtaak succesvol bijgewerkt",
  Teamtododeletedsuccessfully: "Teamtaak succesvol verwijderd!",
  Teamtodocancelledsuccessfully: "Teamtaak succesvol geannuleerd",
  Teamtodosubmittedsuccessfully: "Teamtaak succesvol ingediend",
  TeamGroupdeletedsuccessfully: "Teamgroep succesvol verwijderd",
  Employee: "Medewerker",
};
